module.exports = __webpack_public_path__ + "static/media/Cooleaf-Photo-Album.0536eab8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Cooleaf/Cooleaf-Photo-Album.gif
// module id = 129
// module chunks = 0